var map = {
	"./24h_serv.svg": 1485,
	"./ClaminsCreate.svg": 6388,
	"./Map.svg": 4943,
	"./Segurnet-blanco.svg": 8371,
	"./archivosRec.svg": 336,
	"./comunications/circular-05-2025.jpeg": 4098,
	"./download.png": 4880,
	"./facebook.svg": 5925,
	"./icn_modal.svg": 585,
	"./incHomeAnimate.svg": 7774,
	"./incHomeAnimate2.svg": 3725,
	"./incHomeAnimateTrrue.svg": 2690,
	"./instagram.svg": 7927,
	"./logo.svg": 5522,
	"./logo15a.svg": 7467,
	"./mail.png": 1887,
	"./polizas.svg": 2739,
	"./polizasStock.svg": 5045,
	"./reclamaciones.svg": 2990,
	"./search.svg": 3655,
	"./segurnetB.svg": 1725,
	"./spinner.gif": 4898,
	"./tel.svg": 648,
	"./work-in-progress.png": 8572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;